import Image from 'app/Components/Shared/Image/image';
import React, {ReactNode, ReactNodeArray} from 'react';
import SelfCareNavBarPlusBlockData from '../../../Models/Content/SelfCareNavBarPlusBlockData';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import { Col } from 'reactstrap';
import { connect } from 'react-redux';
import { showAllActions } from '../SelfCareNavBarBlock/selfCareNavBarSlice';
import Config from '../../../Config';

export default class SelfCareNavBarPlusBlock extends EpiComponent<SelfCareNavBarPlusBlockData> {
  public render(): null | ReactNode | ReactNodeArray {
    const data = {
      text: this.props.data.title.value,
      selfCareIcon: this.props.data.plusSelfCareIcon.value,
      commonTroubleshootingIcon: this.props.data.plusTroubleShootingIcon.value
    };

    return <ConnectedExpandButton data={data} />
  }
}

function ExpandButton({ data, selectedTab, scActions, showAll, maxActions, showAllActions }) {
  const isHidden = showAll || (scActions || []).filter(action => action.mode !== 'unavailable').length < maxActions;
  
  if (isHidden) return null;

  const icon = selectedTab === 'COMMON_TROUBLES' ? data.commonTroubleshootingIcon: data.selfCareIcon;
  
  return (
    <Col className="self-care-navbar-options" onClick={() => showAllActions()}>
      <div className="self-care-image-box">
        <Image className="choicePicBox" alt={data.text} src={Config.epiBaseUrl + icon.url} />
      </div>
      <div className="self-care-image-title">
        {data.text}
      </div>
    </Col>
  );
}

const ConnectedExpandButton = connect((state: any ) => ({
  selectedTab: state.selfCareNavBarBlock.selectedTab,
  scActions: state.selfCareNavBarBlock.scActions,
  showAll: state.selfCareNavBarBlock.showAll,
  maxActions: state.selfCareNavBarBlock.maxActions
}), (dispatch) => ({
  showAllActions: () => dispatch(showAllActions())
}))(ExpandButton);
